import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
	Row,
	Col,
	Card,
	CardBody,
	CardHeader,
	Container,
	Button,
	FormGroup,
	InputGroup,
	InputGroupAddon,
	Input,
	Table,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";
import swal from "sweetalert";
import {
	getProductQualities,
	SetParams,
	ProductQualitiesDelete,
	modelOpen,
	modelClose,
} from "../../../store/Masters/ProductQuality/action";

class ProductsQuality extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modal_static: false,
			isAlertOpen: false,
			leftSideBarType: "icon",
		};
	}

	componentDidMount() {
		this.props.getProductQualities(this.props.params || {});
	}

	handleDelete = (id) => {
	
		this.props.ProductQualitiesDelete(id, this.props.history);
	};

	deleteRecord = (record) => {
		swal({
			title: "Are you sure?",
			text: "Once deleted, you will not be able to recover this data!",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				this.handleDelete(record.id);
			} else {
				swal("Your record is safe!", { timer: 1500 });
			}
		});
	};

	handleSearch = (e) => {
		if (e.key === "Enter") {
			this.props.getProductQualities({
				...this.props.params,
				page: 1,
				search: e.target.value,
			});
		}
	};

	openPage = (pageNo) => {
		this.props.SetParams({ ...this.props.params, page: pageNo });
		this.props.getProductQualities({ ...this.props.params, page: pageNo });
	};

	render() {
		const { qualityProductlist, params } = this.props;

		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Card>
							<CardHeader className="bg-transparent border-bottom">
								<Link to="/MastersDashboard">
									<i className="ri-arrow-go-back-fill font-size-18"></i>
								</Link>
								<h4 className="card-title-18 d-inline-block ml-2">
									Product Quality Master
								</h4>
								<div className="float-right">
									<Button
										type="button"
										color="primary"
										className="waves-effect waves-light"
										href="/AddProductsQuality/0">
										Add New Product Quality
									</Button>
								</div>
							</CardHeader>

							<CardBody>
								<Row>
									<Col xs={9}>
										<Row>
											<Col md={4}>
												<FormGroup className="m-0">
													<InputGroup>
														<Input
															type="text"
															name="search"
															placeholder="Search"
															value={
																params.search ||
																""
															}
															onChange={(e) =>
																this.props.SetParams(
																	{
																		...params,
																		search: e
																			.target
																			.value,
																		page: 1,
																	}
																)
															}
															onKeyDown={
																this
																	.handleSearch
															}
														/>
														<InputGroupAddon addonType="append">
															<Button
																color="light"
																type="submit"
																onClick={() =>
																	this.props.getProductQualities(
																		{
																			...params,
																			page: 1,
																		}
																	)
																}>
																<i className="ri-search-line"></i>
															</Button>
														</InputGroupAddon>
													</InputGroup>
												</FormGroup>
											</Col>

											{/* Pagination */}
											<Col md={8}>
												<div className="float-right">
													<Pagination aria-label="Page navigation">
														<PaginationItem
															disabled={
																params.page <= 1
															}>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		1
																	)
																}
																first
															/>
														</PaginationItem>

														{params.page > 1 && (
															<PaginationItem>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			params.page -
																				1
																		)
																	}>
																	{params.page -
																		1}
																</PaginationLink>
															</PaginationItem>
														)}

														<PaginationItem active>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		params.page
																	)
																}>
																{params.page}
															</PaginationLink>
														</PaginationItem>

														{params.page + 1 <=
															params.no_of_pages && (
															<PaginationItem>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			params.page +
																				1
																		)
																	}>
																	{params.page +
																		1}
																</PaginationLink>
															</PaginationItem>
														)}

														<PaginationItem
															disabled={
																params.page ===
																params.no_of_pages
															}>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		params.no_of_pages
																	)
																}
																last
															/>
														</PaginationItem>
													</Pagination>
												</div>
											</Col>
										</Row>

										{/* Table */}
										<div
											className="table-responsive m-0"
											style={{
												maxHeight: "550px",
												overflowY: "auto",
											}}>
											<Table
												bordered
												hover
												responsive
												className="mb-0 p-0 table-centered">
												<thead className="bg-light text-center">
													<tr>
														<th>Product Code</th>

														<th>Product</th>
														<th>Quality</th>
														<th>Created On</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													{qualityProductlist &&
													qualityProductlist.length >
														0 ? (
														qualityProductlist.map(
															(product, key) => (
																<tr key={key}>
																	<td className="text-center">
																		{
																			product
																				.product
																				.code
																		}
																	</td>

																	<td className="text-center">
																		{product
																			.product
																			?.name ||
																			"-"}
																	</td>
																	<td className="text-center">
																		{product.qualities &&
																		product
																			.qualities
																			.length >
																			0
																			? product.qualities
																					.map(
																						(
																							q
																						) =>
																							q.name
																					)
																					.join(
																						", "
																					)
																			: "-"}
																	</td>
																	<td>
																		<h5 className="font-size-14">
																			{
																				product.createdon?.split(
																					"T"
																				)[0]
																			}
																		</h5>
																	</td>

																	<td className="nowrap text-center">
																		<Link
																			to={`/AddProductsQuality/${product.id}`}
																			color="primary">
																			<i
																				className="mdi mdi-pencil-box-outline mr-2 font-size-18"
																				title="Edit Product Quality"
																				style={{
																					cursor: "pointer",
																					color: "#fc6f03",
																				}}></i>
																		</Link>
																		<i
																			className="mdi mdi-delete mr-2 font-size-18"
																			title="Delete Product Quality"
																			style={{
																				cursor: "pointer",
																				color: "#ff0000",
																			}}
																			onClick={() =>
																				this.deleteRecord(
																					product
																				)
																			}></i>
																	</td>
																</tr>
															)
														)
													) : (
														<tr>
															<td
																colSpan="5"
																className="text-center">
																No data found
															</td>
														</tr>
													)}
												</tbody>
											</Table>
										</div>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => {
	const { qualityProductlist, model, message, params } = state.qualityProduct;
	return { qualityProductlist, model, message, params };
};

export default connect(mapStateToProps, {
	getProductQualities,
	SetParams,
	ProductQualitiesDelete,
	modelOpen,
	modelClose,
})(ProductsQuality);
